export default "__VITE_ASSET__Ajl8c_9k__"